import { makeStyles } from '@material-ui/core'

export const filterStyles = makeStyles((theme: any) => {
    const fieldBase = {
        backgroundColor: '#f5f5f5',
        borderRadius: theme.shape.borderRadius,
        border: '1px solid #ddd',
    }
    return {
        formWrapper: {
            height: theme.logs.filterHeight,
            alignItems: 'flex-start',
            paddingTop: theme.spacing(2),
            paddingLeft: theme.spacing(1),
            fontFamily: theme.typography.fontFamily,
            fontSize: '0.875rem',
        },
        row: {
            display: 'flex',
            alignItems: 'center',
            gap: theme.spacing(2),
        },
        secondRow: {
            marginTop: theme.spacing(1),
        },
        field: {
            flex: '1 1 0',
            minWidth: 0,
        },
        input: {
            ...fieldBase,
            overflow: 'hidden',
            '& .MuiFilledInput-root': {
                backgroundColor: '#f5f5f5',
                borderRadius: theme.shape.borderRadius,
                height: '40px',
                boxShadow: 'none',
                '&:before, &:after': {
                    display: 'none',
                },
            },
            '& .MuiFilledInput-input': {
                padding: '10px 12px',
            },
        },
        datePickerWrapper: {
            width: '100%',
            '& .react-datepicker-wrapper, & .react-datepicker__input-container': {
                width: '100%',
            },
        },
        checkbox: {
            color: '#6100ED',
        },
        checkboxLabel: {
            marginLeft: -12,
            marginRight: theme.spacing(2),
            '& .MuiFormControlLabel-label': {
                fontSize: '0.875rem',
            },
        },
        buttons: {
            marginLeft: 'auto',
            display: 'flex',
            gap: theme.spacing(1),
        },
        button: {
            whiteSpace: 'nowrap',
        },
    }
})
